<template>
  <div class="about">
    <van-nav-bar
      :title="$t('wd')"
      left-arrow
      @click-left="onClickLeft"
    />
    <ul>
       <li class="van-hairline--bottom"  v-for="(item,index) in list" :key="index" @click="gotoPath(item.url)">
        <div>
          <van-icon :name="item.icon" />
          {{item.name}}
        </div>
        <span><van-icon name="arrow" size="1rem" /></span>
      </li>

      <li class="van-hairline--bottom" @click="loginOut">
        <div>
          <van-icon name="delete-o" />
          {{$t('tcdl')}}
        </div>
        <span><van-icon name="arrow" size="1rem" /></span>
      </li>

    </ul>
    <Footer :actives="3" ref="footer" :person_type="UserInfo.person_type"></Footer>
  </div>
</template>
<script>
import Footer from "@/components/footer"
import { Dialog } from 'vant';
import { showDialog } from 'vant';
export default {
  components:{
    Footer
  },
  data(){
    return{
		UserInfo:JSON.parse(window.localStorage.getItem("getTokendata")),
      list:[
        {
          name:this.$t('txjl'),
          icon:'label-o',
          url:'/traffic'
        },
        {
          name:this.$t('fkjl'),
          icon:'label-o',
          url:'/record'
        },
        {
          name:this.$t('kqrb'),
          icon:'comment-o',
          url:'/daily'
        },
        {
          name:this.$t('xgmm'),
          icon:'manager-o',
          url:'/changpas'
        },
        {
          name:this.$t('zhxx'),
          icon:'comment-o',
          url:'/zhxx'
        },
        {
          name:this.$t('fkwm'),
          icon:'service-o',
          url:'/feedback'
        },
        
      ]

    }
  },
  
  mounted(){
    // this.qrCodeCreate()
  },
  methods:{

    onClickLeft(){
      this.$router.go(-1);
    },

    gotoPath(url){
      if(url=='/zhxx'){
        Dialog.confirm({
          title: this.$t('zhxx'),
          message: this.UserInfo.mobile,
          confirmButtonText:this.$t('qd'),
          cancelButtonText:this.$t('qx')
        })
        return
      }
      console.log(url)
      this.$refs.footer.paht = url
      this.$router.push({ path: url })
    },
    // 退出登录
    loginOut(){
      Dialog.confirm({
        message: this.$t('sfqdtc'),
        confirmButtonText:this.$t('qd'),
        cancelButtonText:this.$t('qx')
      })
        .then(() => {
            window.localStorage.removeItem('getTokendata')
            window.localStorage.removeItem('address')
          this.$router.push({ path: '/login' })
        })
        .catch(() => {
          // on cancel
        });
    }
  }
}
</script>
<style scoped>
.about ul{
  width: 90%;
  margin:0 auto;
  text-align: left;
}
.about ul li{
  display: flex;
  justify-content: space-between;
  height: 40px;
  line-height: 40px;
}
.about .qroud >>>.van-dialog__content{
  /* width: 277px; */
  height: 220px;
  padding: 50px 10px 10px 10px;
  text-align: center;
}
.about .qrouds >>>.van-dialog__content{
  /* width: 277px; */
  height: auto;
  padding: 20px 10px 0px 10px;
  text-align: center;
}
.qurys{
  height: 40px;
  line-height: 40px;
  text-align: center;
  margin-top: 20px;
  display: flex;
  justify-content: space-around;
}
.guanb{

}
</style>